<template>
	<div class="df1" v-loading.fullscreen.lock="loading">
		<el-form ref="form" :model="form" :rules="rules"  
		              label-position="top">
					 
			<el-form-item label="Name" prop="name" > 
				<el-input v-model="form.name" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="E-mail" prop="eMail">
				<el-input v-model="form.eMail" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="Country" prop="country">
				 <el-input v-model="form.country" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="Company Type" prop="companyType">
				<el-select v-model="form.companyType" placeholder=""  filterable     :style="{width: '100%'}" :popper-append-to-body="false" >
					<el-option v-for="(item, index) in companyTypeOption" :key="index" :label="item.label"
							   :value="item.value" ></el-option>
				 </el-select>
			</el-form-item> 
			<el-form-item label="Current Distributor" prop="current">
				 <el-input v-model="form.current" placeholder="" ></el-input>
			</el-form-item> 
			
			<el-form-item label="Reasons for Ending Cooperation" prop="arrangement">
				 <el-input v-model="form.arrangement" placeholder="" ></el-input>
			</el-form-item> 
			
			<el-form-item label="List of Previously Released Songs (must include album name, song title, artist, ISRC code, etc.)" prop="previously">
				 <el-input v-model="form.previously" placeholder="Can be provided in Google Drive Link" ></el-input>
			</el-form-item> 
			
			<el-form-item label="Where did you know EWWAY?" prop="know">
				 <el-input v-model="form.know" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="What areas do you hope EWWAY can assist you with?" prop="hope">
				 <el-input v-model="form.hope" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="Regions for Distribution." prop="regions">
				 <el-input v-model="form.regions" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="Platforms for Distribution (All platforms by EWway or specific platforms)" prop="dsp">
				 <el-input v-model="form.dsp" placeholder="" ></el-input>
			</el-form-item> 
			<el-form-item label="Numbers of existing songs that can be released through EWway." prop="trackCount">
					 <el-input v-model="form.trackCount" placeholder="" ></el-input>
			</el-form-item>
			<el-form-item label="The planned release frequency in the future (number of songs released per month/quarter)." prop="plannedc">
					 <el-input v-model="form.plannedc" placeholder="" ></el-input>
			</el-form-item>
			<el-form-item label="The preview links for future released songs" prop="plannedl">
					 <el-input v-model="form.plannedl" placeholder="Can be provided in Google Drive Link" ></el-input>
			</el-form-item>
			<el-form-item label="Music Type" prop="musicType">
				<el-select v-model="form.musicType" placeholder=""  filterable     :style="{width: '100%'}" :popper-append-to-body="false" >
					<el-option v-for="(item, index) in musicTypeOption" :key="index" :label="item.label"
							   :value="item.value" ></el-option>
				 </el-select>
			</el-form-item> 
			<el-form-item label="" prop="originalSong">
				Original Content with Complete Copyright Ownership
				<el-radio-group v-model="form.originalSong">
				    <el-radio label="yes">yes</el-radio>
				    <el-radio label="no">no</el-radio>
				</el-radio-group>
			</el-form-item> 
			<el-form-item label="Audio Language" prop="audioLanguage">
				<el-select v-model="form.audioLanguage" placeholder=""  filterable     :style="{width: '100%'}" :popper-append-to-body="false" >
					<el-option v-for="(item, index) in audioLanguageOption" :key="index" :label="item.label"
							   :value="item.value" ></el-option>
				</el-select>
			</el-form-item> 
			
			<el-form-item label="Your artist pages (YouTube, Spotify, Apple Music, etc.)" prop="artist">
				<el-button type="primary" size="small" icon="el-icon-plus" plain @click="addArtist">Add Artist</el-button>
				
				<div v-for="(itemF, indexF) in form.artist" :style="{'height': (itemF.length*45)+ 'px',backgroundColor:'#F7F7F7',marginBottom:'20px',padding:'20px'}" >
					<div v-for="(item, index) in itemF" :style="{'height':'50px'}">
						<el-input v-model="item.name" v-if="index==0" placeholder="Artist Name"  style="width: 14%;float: left;margin-bottom: 5px;" ></el-input>
						
						<div style="width:12%;float: right;height: 40px;margin-bottom: 5px;" >
							<div style="width:100%;height: 40px;" >
								<div style="width:20px;float: left;text-align: center; height: 20px;padding: 10px ;" v-if="index==0" @click="addArtItem(indexF)"><img src="@/assets/images/svg/add.svg" /></div>
								<div style="width:20px;float: left;text-align: center; height: 20px;padding: 10px ;" v-if="indexF !=0 && index==0" @click="delArtItem(indexF,index)"><img src="@/assets/images/svg/del.svg" /></div>
								<div style="width:20px;float: left;text-align: center; height: 20px;padding: 10px ;" v-if="index!=0" @click="subArtItem(indexF,index)"><img src="@/assets/images/svg/sub.svg" /></div>
								
								<!-- <el-button type="primary" size="mini"   		 plain style="float:left;width:50%;height:40px;margin-left:0;" round v-if="index==0" icon="el-icon-plus"></el-button>
								<el-button type="primary" size="mini" @click="delArtItem(indexF,index)"  plain style="float:left;width:50%;height:40px;margin-left:0;" round v-if="indexF !=0 && index==0" icon="el-icon-delete"></el-button>
								<el-button type="primary" size="mini" @click="subArtItem(indexF,index)"  plain style="float:left;width:50%;height:40px;margin-left:0;" round v-if="index!=0" icon="el-icon-minus"></el-button>
							 -->
							</div>
						</div>
						
						<el-input v-model="item.link" placeholder="Artist's Page Link" style="width: 50%;float: right ;margin-left: 1%;margin-bottom: 5px;"></el-input>
						
						<el-select v-model="item.platform" placeholder="Select Platform"  filterable     style="width: 22%;float: right ;margin-left: 1%;margin-bottom: 5px;" :popper-append-to-body="false" >
							<el-option v-for="(item2, index2) in platformOption" :key="index2" :label="item2.label"
									   :value="item2.value" ></el-option>
						</el-select>
					</div>
					
					
				</div>
				
			</el-form-item>
			
		<!-- 	<el-form-item label="How many tracks are in your catalog?" prop="trackCount">
				 <el-input v-model="form.trackCount" placeholder="" ></el-input>
			</el-form-item> -->
			
			<!-- <el-form-item label="Your artist pages (YouTube, Spotify, Apple Music, etc.)" prop="artist">
				<span class="labelSpan" style="left: 375px;"> When listing multiple items or elements, use commas for separation</span>
				 <el-input v-model="form.artist" placeholder="" type="textarea" 
						resize="none"    :autosize="{ minRows: 4 }" ></el-input>
			</el-form-item> -->
			
			
			
			<el-form-item label="Description"  prop="description">
			  <el-input v-model="form.description" type="textarea" 	placeholder=" Genre Types, Number of Tracks, Artist Audience, etc." 
						resize="none"    :autosize="{ minRows: 4 }" ></el-input>
			</el-form-item>
			<el-form-item label="" prop="check1">
			  <el-checkbox v-model="form.check1" ></el-checkbox>
			  <span class="checkBoxClass" >We prioritize copyright issues and uphold a strict anti-fraudulence policy. To distribute content via EWWAY, it's imperative to possess exclusive rights to the content. Should any copyright-related issues arise, we'll promptly remove the content. We appreciate your understanding in this matter.</span><br>
			</el-form-item>
			
			 <el-button type="primary" @click="add">Submit</el-button>
					
		</el-form>
		
	</div>
	
</template>

<script>
import axios from 'axios';
export default {
	name : "Form1",
	data() {
		//艺人选择
		const checkArtist = (rule, value, callback) => {
			for (var i = 0; i < value.length; i++) {
				let v = value[i];
				for (var j = 0; j < v.length; j++) {
					let ll = v[j];
					if(i==0&& j==0){
						if(ll['name']==""){
							return callback(new Error( "not empty" ))
						}
					}
					if(ll['platform']==""){
						return callback(new Error( "not empty" ))
					}
					if(ll['link']==""){
						return callback(new Error( "not empty" ))
					}else{
						try {
							new URL(ll['link']);
						} catch (_) {
							return callback(new Error( "URL format error" ))
						}
					}
				}
			}
			return callback()
		};
			
		return {
			
			//公司类型
			companyTypeOption:[{"label":"Independent Artist","value":"Independent Artist"},
							{"label":"Label","value":"Label"},
							{"label":"Management Company","value":"Management Company"},
							{"label":"Distributor/Aggregator","value":"Distributor/Aggregator"},
							{"label":"Artist Services Platform","value":"Artist Services Platform"},
							{"label":"Other","value":"Other"},
							],
			//音乐类型
			musicTypeOption:[{"label":"Vocal music","value":"vocalMusic"},{"label":"Instrument","value":"Instrument"}],
			//语言
			audioLanguageOption:[
							{"label":"Chinese","value":"Chinese"},
							{"label":"English","value":"English"},
							{"label":"Japanese","value":"Japanese"},
							{"label":"Korean","value":"Korean"},
							{"label":"Vietnamese","value":"Vietnamese"},
							{"label":"Hindi","value":"Hindi"},
							{"label":"Other","value":"Other"},
							],
			//平台信息
			platformOption:[
				{"label":"YouTube Channel","value":"YouTube Channel"},
				{"label":"YouTube Music","value":"YouTube Music"},
				{"label":"Apple Music","value":"Apple Music"},
				{"label":"Spotify","value":"Spotify"},
				{"label":"Deezer","value":"Deezer"},
				{"label":"Soundcloud","value":"Soundcloud"},
				{"label":"AWA","value":"AWA"},
				{"label":"Amazon","value":"Amazon"},
				{"label":"Tencent Music","value":"Tencent Music"},
				{"label":"NetEase Cloud Music","value":"NetEase Cloud Music"},
				{"label":"others","value":"others"},
			],
			form:{
				originalSong : "yes",
				artist:[[{"name":"","platform":"","link":""}]],
				check1:false,
			},
			rules:{
				name: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				eMail: [
				  { required: true, message: "not empty", trigger: "blur" },
				  {  message: "email format error", type:"email", trigger: "blur" }
				],
				country: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				companyType: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				trackCount: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				musicType: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				audioLanguage: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				arrangement: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				know: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				hope: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				artist: [
				  { required: true, validator: checkArtist, trigger: ["blur","change"]  }
				],
				regions: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				description: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				dsp: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				check1: [
				  { required: true, message: "field required", trigger: ["blur","change"] }
				],				
				dsp: [
				  { required: true, message: "not empty", trigger: "blur" }
				],				
				previously: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				plannedc: [
				  { required: true, message: "not empty", trigger: "blur" }
				],
				plannedl: [
				  { required: true, message: "not empty", trigger: "blur" }
				],		
				current: [
				  { required: true, message: "not empty", trigger: "blur" }
				],	
				
			},
			loading:false
		}
	},
	methods:{
		//提交
		add(){
			this.$refs["form"].validate(valid => {
				if (valid) {
					this.form.artist2  = JSON.stringify(this.form.artist);
					this.loading = true
					axios.post('https://cms.ewway.com/ewway-api/feedback/distribution', this.form)
					// axios.post('dev-api/feedback/distribution', this.form)
						.then(response => {
							this.loading = false
						  // 处理返回的数据
						  if(response.data.code===200){
							 this.$message({
									type: 'success',
									message: "Your request received!  We're working hard to reply ASAP. Thanks for your patience!",
									customClass :'customClass',
									duration:2000,
							 }); 
							 this.$refs['form'].resetFields();
							 this.form.artist=[[{"name":"","platform":"","link":""}]];
						  }else{
							  this.$message({
									type: 'error',
									message: "error",
									customClass :'customClass',
									duration:2000,
							  });
						  }
						  
						})
						.catch(error => {
						  console.error(error);
						  this.loading = false
						  // 错误处理逻辑
						  this.$message({
									type: 'error',
									message: "error",
									customClass :'customClass',
									duration:2000,
						  });
						});
				}
					
			});
		},
		//添加艺人
		addArtist(){
			if(this.form.artist.length<5){
				this.form.artist.push([{"name":"","platform":"","link":""}]);
				return ;
			}
			this.$message({
				type: 'error',
				message: "You can add up to five artists!",
				customClass :'customClass',
				duration:2000,
			});
		},
		//添加艺人具体信息
		addArtItem(indexF){
			if(this.form.artist[indexF].length<3){
				this.form.artist[indexF].push({"name":"","platform":"","link":""});
				return ;
			}
			this.$message({
				type: 'error',
				message: "Each artist can have up to three different platform homepage links!",
				customClass :'customClass',
				duration:2000,
			});
		},
		delArtItem(indexF,index){
			this.form.artist.splice(indexF,1);
		},
		subArtItem(indexF,index){
			this.form.artist[indexF].splice(index,1);
		},
	}
}
	
	
</script>

<style >
	.df1{
		width:80%;
		margin-left:10%;
		text-align: left;
	}
	.customClass{
		font-size:12px;
	}
	.labelSpan{
		position: absolute;
		top: -50px;
		font-size: 12px;
		color: #A5A3BE;
	}
</style>